export class ErrorHelper {
  static extractMessageFromError(e) {
    if (e?.response?.data?.message) {
      return e?.response?.data?.message;
    }
    return null;
  }
}
